import { render } from "./KnParameterSavedParametersDialog.vue?vue&type=template&id=6dc57e43&scoped=true&ts=true"
import script from "./KnParameterSavedParametersDialog.vue?vue&type=script&lang=ts"
export * from "./KnParameterSavedParametersDialog.vue?vue&type=script&lang=ts"

import "./KnParameterSavedParametersDialog.vue?vue&type=style&index=0&id=6dc57e43&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc57e43"]])

export default __exports__